// Routes inside the RequireOnboarding group that legitimately render for
// logged-OUT users — the central auth gate must NOT redirect these.
//
// Everything else in that route group is auth-required. Routes defined OUTSIDE
// the group (e.g. /buyer-signup/*, /deals/:slug/*, /spencers-list*) are not
// wrapped by RequireOnboarding, so they don't need to be listed here.
//
// Membership verified against the route audit:
//   - ShareComps (/comps/...) calls getCompanyReport(null) for logged-out viewers.
//   - /sample-report + /demos/* are prospect-facing (RunComps self-routes to /sign-up).
//   - policy / pricing / report-loading render statically.
//   - OAuth callbacks self-handle their code exchange and must not be pre-empted.
//   - /claim + /accept-invite have their own token flows.
//   - /login + /sign-up are the auth pages themselves.

const EXACT_PUBLIC_ROUTES = new Set([
    '/privacy-policy',
    '/terms-conditions',
    '/pricing',
    '/report-loading',
    '/sample-report',
    '/login',
    '/sign-up',
    '/claim',
    '/accept-invite',
    '/oauth/x/callback',
    '/salesforcecallback',
    '/fubcallback',
]);

// Trailing slashes are intentional: '/comps/' must NOT match '/comp-tracking/…'.
const PUBLIC_ROUTE_PREFIXES = [
    '/comps/', // ShareComps public share links
    '/demos/', // RunComps prospect demo links
];

export const isPublicRoute = (pathname) => {
    if (typeof pathname !== 'string') return false;
    if (EXACT_PUBLIC_ROUTES.has(pathname)) return true;
    return PUBLIC_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};
